// Translations in English
export const en = {
  common: {
    welcome: "Welcome",
    logout: "Log Out",
    login: "Log In",
    loading: "Loading...",
    error: "Error",
    success: "Success",
    cancel: "Cancel",
    save: "Save",
    delete: "Delete",
    edit: "Edit",
    back: "Back",
    next: "Next",
    previous: "Previous",
    search: "Search",
    filter: "Filter",
    close: "Close",
  },
  login: {
    title: "Log In",
    subtitle: "Access your Auriga account",
    button: "Log In with Authentik",
    checking: "Checking session...",
    redirecting: "Redirecting...",
  },
  dashboard: {
    title: "Dashboard",
    welcome: "Welcome",
    userInfo: "User Information",
    email: "Email",
    id: "ID",
    apiInfo: "API Information",
    noUserData: "No user information available.",
    sections: "Available Sections",
    qualityDashboard: "Quality Dashboard",
    maintenanceDashboard: "Maintenance Dashboard",
    adminDashboard: "Administration Dashboard",
    noAccess: "You don't have access to specialized sections. Contact the administrator to obtain permissions.",
    permissions: "Permissions Information",
    factories: "Factories",
    roles: "Roles",
    departments: "Departments",
    groups: "Groups",
    none: "None",
    noneFound: "None",
  },
  quality: {
    title: "Quality Dashboard",
    permissions: "Permissions Information",
    accessChecks: "Access Checks",
    factoryAccess: "Access to",
    roleIn: "Role",
    features: "Quality Features",
    inspections: "Inspection management",
    qualityControl: "Quality control",
    nonConformities: "Non-conformity reports",
    trends: "Trend analysis",
  },
  maintenance: {
    title: "Maintenance Dashboard",
    permissions: "Permissions Information",
    accessChecks: "Access Checks",
    factoryAccess: "Access to",
    roleIn: "Role",
    features: "Maintenance Features",
    planning: "Maintenance planning",
    workOrders: "Work orders",
    equipment: "Equipment management",
    history: "Maintenance history",
  },
  admin: {
    title: "Administration Dashboard",
    permissions: "Permissions Information",
    accessChecks: "Access Checks",
    group: "Group",
    features: "Administration Features",
    users: "User management",
    system: "System configuration",
    reports: "Administrative reports",
    audit: "Audit and logs",
  },
  navigation: {
    dashboard: "Dashboard",
    general: "General",
    productive: "Production Management",
    people: "People Management",
    quality: "Quality Management",
    processes: "Process Management",
    assets: "Asset Management",
    maintenance: "Maintenance Management",
    safety: "Prevention and Safety",
    configuration: "General Configuration",
    system: "System",
    administration: "Administration",
    mobile: "Mobile",
    orders: "Manufacturing Orders",
    scheduling: "Scheduling",
    oee: "OEE and Metrics",
    materials: "Materials and Consumables",
    traceability: "Batches and Traceability",
    assetHierarchy: "Hierarchy of Assets",
    lines: "Production Lines",
    availabilityStates: "Status and Availability",
    technicalSpecs: "Technical Specifications",
    assetsRegistration: "Assets Registration",
    productsRegistration: "Products Registration",
    shifts: "Shifts",
    laborCalendar: "Labor Calendar",
    employees: "Employees",
    assignedShifts: "Assigned Shifts",
    attendance: "Attendance",
    assignments: "Assignments",
    personalAssignment: "Personal Assignment",
    specialExits: "Absences",
    hoursControl: "Hours Control",
    evaluations: "Evaluations",
    masterData: "Process Master Data",
    processParameters: "Process Parameters",
    bomRoutes: "BOM and Routes",
    workInstructions: "Work Instructions",
    events: "Events",
    energy: "Energy",
    processControl: "Process Control",
    automaticProcesses: "Automated Processes",
    inspectionPlans: "Inspection Plans",
    selfControl: "Self-Control Records",
    qualityCharacteristics: "Quality Characteristics",
    defects: "Defects and Nonconformities",
    statisticalControl: "Statistical Process Control",
    correctiveActions: "Corrective Actions",
    certificates: "Certificates and Compliance",
    maintenancePlans: "Maintenance Plans",
    assignmentPlans: "Assignment Plans",
    executionPlans: "Execution Plans",
    spareParts: "Spare Parts Inventory",
    kpi: "KPI and Analytics",
    risks: "Risks and Hazards",
    safetyInspections: "Safety Inspections",
    accidents: "Accidents and Incidents",
    trainings: "Training",
    ppe: "Personal Protective Equipment (PPE)",
    occupationalHealth: "Occupational Health",
    companyConfig: "Company Information",
    plantsConfig: "Plants Configuration",
    calendarConfig: "Work Calendar",
    shiftsConfig: "Shift Definition",
    timezonesConfig: "Time Zones",
    unitsConfig: "Units of Measurement",
    currenciesConfig: "Currencies",
    employeeManagement: "Employee Management",
    dashboards: "Grafana Dashboards",
    security: "Monitor",
    logs: "Logs",
    users: "Users",
    roles: "Roles",
    rolesPermissions: "Roles and Permissions",
    scanQR: "Scan QR",
  },
  errors: {
    notAuthenticated: "Not authenticated",
    accessDenied: "Access Denied",
    noPermission: "You don't have permission to access this section.",
    requirements: "Requirements",
    factory: "Factory",
    department: "Department",
    role: "Role",
    group: "Group",
    backToDashboard: "Back to Dashboard",
  },
  produccion: {
    lotesTrazabilidad: {
      title: "Batches and Traceability",
      description: "Batch traceability",
      import: "Import",
      batches: "Batches",
      traceability: "Traceability",
      salaMezcla: "Mixing Room",
      salaMezclaTitle: "Mixing Room Control",
      salaMezclaDesc: "Pallet (HU / SSCC) reception from PDA",
      openPda: "Open PDA",
      copyPdaLink: "Copy PDA link",
      huReceived: "HU received",
      huDuplicate: "HU already received",
      registerHu: "Register HU",
      manualEntry: "Manual",
      scanHint: "Scan the pallet barcode or use manual entry",
    },
  },
};

